<template>
  <CollapseFilters ref="collapse">
    <Form ref="form" @submit.prevent>
      <div class="row g-4">
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("dataInicial") }}</label>
          <DateInput v-model="filters.initialDate" required />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("dataFinal") }}</label>
          <DateInput v-model="filters.endDate" required />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("agrupar") }}</label>
          <select v-model="filters.group" class="form-select">
            <option value="0">
              {{ $t("porServicos") }}
            </option>
            <option value="1">
              {{ $t("porCategorias") }}
            </option>
          </select>
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("status") }}</label>
          <StatusDropdown v-model="filters.status" />
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("usuario") }}</label>
          <UsersDropdown v-model="filters.users" />
        </div>
      </div>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <LoadingButton class="btn-primary" :loading="loading" @click="onClick">
          <i class="bi bi-filter" /> {{ $t("filtrar") }}
        </LoadingButton>
      </div>
    </Form>
  </CollapseFilters>
</template>

<script>
import CollapseFilters from '@/modules/shared/components/CollapseFilters.vue';
import Form from '@/modules/core/components/FormInput.vue';
import DateInput from '@/modules/core/components/DateInput.vue';
import StatusDropdown from '@/modules/shared/components/StatusDropdown.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import UsersDropdown from '@/modules/shared/components/UsersDropdown.vue';

export default {
  components: { CollapseFilters, Form, DateInput, StatusDropdown, UsersDropdown, LoadingButton },
  props: {
    loading: { type: Boolean, required: true },
  },
  emits: ['filter'],
  data: () => ({
    filters: {
      initialDate: new Date().toLocaleDateString(),
      endDate: new Date().toLocaleDateString(),
      group: '0',
      status: [3],
      users: [],
    },
  }),
  mounted() { this.$emit('filter', this.filters); },
  methods: {
    onClick() {
      if (this.$refs.form.validate()) {
        this.$emit('filter', this.filters);
        this.$refs.collapse.toggle();
      }
    },
  },
};
</script>
